module.exports = __webpack_public_path__ + "img/sankaku_68_blue.567b9431.png";